import { ref } from 'vue'

export const newNews = ref(false)
